export default __webpack_public_path__ + "static/media/image-study-admin-m@2x.f3c3cae1.webp";